import copy from "fast-copy";
export default copy;
